module.exports = __webpack_public_path__ + "media/images/new_landing/favicon/mstile-310x150-92845c1ff7e0f5dab4c9d91d057af170.png";